import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=67f038ee&scoped=true"
import script from "./edit.vue?vue&type=script&lang=js"
export * from "./edit.vue?vue&type=script&lang=js"
import style0 from "./edit.vue?vue&type=style&index=0&id=67f038ee&prod&scoped=true&lang=css"
import style1 from "./edit.vue?vue&type=style&index=1&id=67f038ee&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f038ee",
  null
  
)

export default component.exports